// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2023 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

import BaseModel from '@glittr/frontend-core/src/plugins/servicelayer/serviceTypes/baseModel';
import WidgetEventFaqResourceViewModel from '../../../../viewModel/resource/WidgetEventFaqResourceViewModel';
import WidgetEventInformationResourceViewModel from '../../../../viewModel/resource/WidgetEventInformationResourceViewModel';
import WidgetEventInformationResourceDTO from '../../dto/resource/WidgetEventInformationResourceDTO';

export default abstract class WidgetEventInformationResourceModel extends BaseModel<WidgetEventInformationResourceDTO> {
  /**
  */
  get classTypeKey() { return this.dto.classTypeKey; }
  set classTypeKey(value) { this.dto.classTypeKey = value; }
  /**
  */
  get title() { return this.dto.title; }
  set title(value) { this.dto.title = value; }
  /**
  */
  get subtitle() { return this.dto.subtitle; }
  set subtitle(value) { this.dto.subtitle = value; }
  /**
  */
  get wordSubtitle() { return this.dto.wordSubtitle; }
  /**
  */
  get summary() { return this.dto.summary; }
  set summary(value) { this.dto.summary = value; }
  /**
  */
  get faq() { return this.getArrayModels(() => this.dto.faq, WidgetEventFaqResourceViewModel)!; }
  set faq(value) { this.setArrayModels(() => this.dto.faq, value); }

  protected transformFromQuery(queries: Record<string, string>): void {
    const qs = {} as Record<string, string>;
    Object.keys(queries).forEach((key) => { qs[key.toLowerCase()] = queries[key]; });
    let value: any;
    this.dto.classTypeKey = qs.classtypekey;
    this.dto.title = qs.title;
    this.dto.summary = qs.summary;
  }
}
